function GuideIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="min-w-[19px] mt-[1px]"
    >
      <g>
        <path
          d="M1.33331 2.00006H5.33331C6.04056 2.00006 6.71883 2.28101 7.21893 2.78111C7.71903 3.28121 7.99998 3.95948 7.99998 4.66673V14.0001C7.99998 13.4696 7.78927 12.9609 7.41419 12.5858C7.03912 12.2108 6.53041 12.0001 5.99998 12.0001H1.33331V2.00006Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 2.00006H10.6667C9.95942 2.00006 9.28115 2.28101 8.78105 2.78111C8.28095 3.28121 8 3.95948 8 4.66673V14.0001C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2108 9.46957 12.0001 10 12.0001H14.6667V2.00006Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export default GuideIcon;
